var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3V21M8.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V6.6C21 6.03995 21 5.75992 20.891 5.54601C20.7951 5.35785 20.6422 5.20487 20.454 5.10899C20.2401 5 19.9601 5 19.4 5H8.6C8.03995 5 7.75992 5 7.54601 5.10899C7.35785 5.20487 7.20487 5.35785 7.10899 5.54601C7 5.75992 7 6.03995 7 6.6V8.4C7 8.96005 7 9.24008 7.10899 9.45399C7.20487 9.64215 7.35785 9.79513 7.54601 9.89101C7.75992 10 8.03995 10 8.6 10ZM8.6 19H13.4C13.9601 19 14.2401 19 14.454 18.891C14.6422 18.7951 14.7951 18.6422 14.891 18.454C15 18.2401 15 17.9601 15 17.4V15.6C15 15.0399 15 14.7599 14.891 14.546C14.7951 14.3578 14.6422 14.2049 14.454 14.109C14.2401 14 13.9601 14 13.4 14H8.6C8.03995 14 7.75992 14 7.54601 14.109C7.35785 14.2049 7.20487 14.3578 7.10899 14.546C7 14.7599 7 15.0399 7 15.6V17.4C7 17.9601 7 18.2401 7.10899 18.454C7.20487 18.6422 7.35785 18.7951 7.54601 18.891C7.75992 19 8.03995 19 8.6 19Z",
    stroke: "#595959",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductblack);
export default __webpack_public_path__ + "static/media/productblack.272d72e1f248353efec7b3fbce586fb6.svg";
export { ForwardRef as ReactComponent };